import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Logo } from "@/components/Logo";

function LegalLayout({ title, children, testid }) {
  return (
    <div className="min-h-screen bg-[#1A1715] px-5 py-10">
      <div className="mx-auto max-w-2xl" data-testid={testid}>
        <div className="flex items-center justify-between">
          <Logo size="text-3xl" />
          <Link
            to="/gave"
            className="flex items-center gap-1.5 text-sm text-[#A8A29E] hover:text-[#D4AF37]"
            data-testid="legal-back"
          >
            <ArrowLeft className="h-4 w-4" /> Tilbake
          </Link>
        </div>
        <h1 className="mt-10 font-serif-display text-4xl font-600 text-[#FDFBF7]">{title}</h1>
        <div className="mt-6 space-y-5 text-sm leading-relaxed text-[#A8A29E]">{children}</div>
        <p className="mt-10 text-xs text-[#A8A29E]/50">
          Sist oppdatert: {new Date().getFullYear()}. Dette er et utkast til juridisk tekst og bør
          gjennomgås av Demo før publisering.
        </p>
      </div>
    </div>
  );
}

function Section({ heading, children }) {
  return (
    <section>
      <h2 className="mb-1.5 font-semibold text-[#FDFBF7]">{heading}</h2>
      <p>{children}</p>
    </section>
  );
}

export function Vilkar() {
  return (
    <LegalLayout title="Vilkår" testid="vilkar-page">
      <Section heading="1. Om tilbudet">
        Ved å registrere deg mottar du én personlig kode som gir rett til én gratis dessert ved
        besøk hos Demo. Tilbudet gjelder per gjest og kan ikke kombineres med andre tilbud.
      </Section>
      <Section heading="2. Bruk av koden">
        Koden er personlig, kan brukes én gang og må vises til servitøren ved besøk. Koden har ingen
        kontantverdi og kan ikke overdras eller løses inn i penger.
      </Section>
      <Section heading="3. Én kode per gjest">
        Hver e-postadresse gir kun én kode. Forsøk på å registrere seg flere ganger med samme
        e-postadresse gir samme, allerede utstedte kode.
      </Section>
      <Section heading="4. Endringer">
        Demo forbeholder seg retten til å endre eller avslutte kampanjen når som helst.
      </Section>
    </LegalLayout>
  );
}

export function Personvern() {
  return (
    <LegalLayout title="Personvernerklæring" testid="personvern-page">
      <Section heading="1. Behandlingsansvarlig">
        Demo er behandlingsansvarlig for personopplysningene som samles inn gjennom
        registreringen.
      </Section>
      <Section heading="2. Hvilke opplysninger vi lagrer">
        Vi lagrer fornavn, e-postadresse, telefonnummer, tidspunkt for registrering, hvilke samtykker
        du har gitt, samt din unike kode og om den er brukt.
      </Section>
      <Section heading="3. Formål">
        Opplysningene brukes for å utstede og administrere din gratis dessert. Dersom du har samtykket
        til markedsføring, bruker vi i tillegg e-post og telefonnummer til å sende deg tilbud, nyheter
        og invitasjoner.
      </Section>
      <Section heading="4. Markedsføringssamtykke">
        Markedsføring sendes kun til gjester som aktivt har samtykket. Har du ikke samtykket, blir du
        ikke lagt til i noen markedsføringsliste. Du kan når som helst trekke tilbake samtykket ditt.
      </Section>
      <Section heading="5. Dine rettigheter">
        Du har rett til innsyn, retting og sletting av dine personopplysninger. Ta kontakt med Demo
        for å utøve dine rettigheter.
      </Section>
    </LegalLayout>
  );
}

export default Vilkar;
